import React, { Component, Fragment } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import {
  BoxLayoutSymetrical,
  SectionHeader,
  BoxTestimonial,
  BoxCaseStudy,
  BoxHashtag,
  BoxCTA,
  WayPointHandler,
  Button,
  Link,
} from 'components';
import { BOX_TYPES } from 'config';
import { data } from './logic';
import './Work.scss';

class Work extends Component {
  renderStories = loadedData =>
    data.map((item, index) => (
      <Fragment key={`box-${index}`}>
        {item.type === BOX_TYPES.CASE_STUDY && (
          <BoxCaseStudy
            data={{
              ...item,
              content: {
                ...item.content,
                coverImage:
                  loadedData[item.content.coverImage].childImageSharp.fluid,
                clientLogo: loadedData[item.content.clientLogo]
                  ? loadedData[item.content.clientLogo].childImageSharp.fluid
                  : item.content.clientLogo,
              },
            }}
            id={item.id}
            additionalClass={'anim-fade-in-bottom'}
          />
        )}
        {item.type === BOX_TYPES.TESTIMONIAL && (
          <BoxTestimonial
            data={{
              ...item,
              content: {
                ...item.content,
                image: loadedData[item.content.image].childImageSharp.fluid,
              },
            }}
            additionalClass={'anim-fade-in-bottom'}
          />
        )}
        {item.type === BOX_TYPES.HASHTAG && (
          <BoxHashtag
            tag={item.content}
            link={item.link}
            id={item.id}
            colors={['white', 'white', 'white']}
            background={loadedData[item.background].childImageSharp.fluid}
            additionalClass={'anim-fade-in-bottom'}
          />
        )}
      </Fragment>
    ));

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            logoEres: file(relativePath: { eq: "logos/eres.png" }) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            logoVirgin: file(relativePath: { eq: "logos/virgin-color.png" }) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            logoIonoview: file(relativePath: { eq: "logos/iono-white.png" }) {
              childImageSharp {
                fluid(maxWidth: 300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            virginImage: file(
              relativePath: { eq: "work/virgin-radio-oman-screen.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            blablaImage: file(
              relativePath: { eq: "work/blablacar-app-mockup.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            eresImage: file(
              relativePath: { eq: "work/eres-yachting-mockups.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            machineLearning: file(
              relativePath: { eq: "work/machine-learning-tile.jpg" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1300) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <WayPointHandler path={'work'}>
            <SectionHeader
              description={
                'At Boldare, we don’t just talk about great products. We make them with our clients. Read our case studies and find out how we’ve helped them bring great products to market: '
              }
            >
              Work
            </SectionHeader>
            <BoxLayoutSymetrical>
              {this.renderStories(loadedData)}
              <BoxCTA name={'work'} />
            </BoxLayoutSymetrical>
            <Link to={'/work/'} additionalClass={'work__explore'}>
              <Button id={'homepage-work'} color={'transparent'}>
                Explore more
              </Button>
            </Link>
          </WayPointHandler>
        )}
      />
    );
  }
}

export default Work;
